import axios from "axios";
import { API } from "@/lib/api";

export const getPlans = () => axios.get(`${API}/payments/plans`).then((r) => r.data);

export const createCheckout = (lookup_key) =>
  axios
    .post(`${API}/payments/checkout`, {
      lookup_key,
      quantity: 1,
      origin_url: window.location.origin,
    })
    .then((r) => r.data);

export const getPaymentStatus = (session_id) =>
  axios.get(`${API}/payments/status/${session_id}`).then((r) => r.data);
